module.exports = __webpack_public_path__ + "img/handshake.c4b40b73.svg";